"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateReportDto = void 0;
class GenerateReportDto {
    ownerId;
    from;
    to;
    advertismentId;
    campaignId;
    displayId;
    reason;
    ref;
    type;
}
exports.GenerateReportDto = GenerateReportDto;
